import { lazy } from 'react';

/**
 * Route-level code splitting. Public auth pages stay eagerly imported in App.jsx
 * so /login does not pull the full application module graph.
 */
export const PortalSelection = lazy(() => import('./pages/PortalSelection'));
export const ProjectPortal = lazy(() => import('./pages/ProjectPortal'));
export const CompanyPortal = lazy(() => import('./pages/CompanyPortal'));
export const UserPortal = lazy(() => import('./pages/UserPortal'));
export const CompanyInductionSearchResult = lazy(() => import('./pages/CompanyInductionSearchResult'));
export const CompanyInduction = lazy(() => import('./pages/CompanyInduction'));
export const HealthMedicalAssessmentIntro = lazy(() => import('./pages/HealthMedicalAssessmentIntro'));
export const HealthMedicalAssessment = lazy(() => import('./pages/HealthMedicalAssessment'));
export const SiteInductionIntro = lazy(() => import('./pages/SiteInductionIntro'));
export const SiteInduction = lazy(() => import('./pages/SiteInduction'));
export const SystemInduction = lazy(() => import('./pages/SystemInduction'));
export const Dashboard = lazy(() => import('./pages/Dashboard'));
export const Timesheets = lazy(() => import('./pages/Timesheets'));
export const Inductions = lazy(() => import('./pages/Inductions'));
export const ExportDownload = lazy(() => import('./pages/ExportDownload'));
export const Incidents = lazy(() => import('./pages/Incidents'));
export const Deliveries = lazy(() => import('./pages/Deliveries'));
export const Inspections = lazy(() => import('./pages/Inspections'));
export const Assets = lazy(() => import('./pages/Assets'));
export const Vehicles = lazy(() => import('./pages/Vehicles'));
export const Settings = lazy(() => import('./pages/Settings'));
export const Projects = lazy(() => import('./pages/Projects'));
export const CreateProject = lazy(() => import('./pages/CreateProject'));
export const EditProject = lazy(() => import('./pages/EditProject'));
export const ProjectDashboard = lazy(() => import('./pages/ProjectDashboard'));
export const GoodCalls = lazy(() => import('./pages/GoodCalls'));
export const GoodCallsDashboard = lazy(() => import('./pages/GoodCallsDashboard'));
export const CloseCallsDashboard = lazy(() => import('./pages/CloseCallsDashboard'));
export const CloseCalls = lazy(() => import('./pages/CloseCalls'));
export const RAMS = lazy(() => import('./pages/RAMS'));
export const ToolboxTalks = lazy(() => import('./pages/ToolboxTalks'));
export const TaskBriefing = lazy(() => import('./pages/TaskBriefing'));
export const GiveTaskBriefing = lazy(() => import('./pages/GiveTaskBriefing'));
export const ViewTaskBriefingDocument = lazy(() => import('./pages/ViewTaskBriefingDocument'));
export const TakeTaskBriefingRegister = lazy(() => import('./pages/TakeTaskBriefingRegister'));
export const Requisitions = lazy(() => import('./pages/Requisitions'));
export const RequisitionForm = lazy(() => import('./pages/RequisitionForm'));
export const RequisitionReturnForm = lazy(() => import('./pages/RequisitionReturnForm'));
export const AssetManagement = lazy(() => import('./pages/AssetManagement'));
export const AssetManagementHome = lazy(() => import('./pages/assetManagement/AssetManagementHome'));
export const PlantAndMachineryDailyCheck = lazy(() => import('./pages/PlantAndMachineryDailyCheck'));
export const EquipmentDailyCheck = lazy(() => import('./pages/EquipmentDailyCheck'));
export const AccessEquipmentDailyCheck = lazy(() => import('./pages/AccessEquipmentDailyCheck'));
export const TemporaryWorksDailyCheck = lazy(() => import('./pages/TemporaryWorksDailyCheck'));
export const GiveBriefing = lazy(() => import('./pages/GiveBriefing'));
export const ViewRAMSDocument = lazy(() => import('./pages/ViewRAMSDocument'));
export const TakeRegister = lazy(() => import('./pages/TakeRegister'));
export const GiveToolboxTalkBriefing = lazy(() => import('./pages/GiveToolboxTalkBriefing'));
export const ViewToolboxTalkDocument = lazy(() => import('./pages/ViewToolboxTalkDocument'));
export const TakeToolboxTalkRegister = lazy(() => import('./pages/TakeToolboxTalkRegister'));
export const Employees = lazy(() => import('./pages/Employees'));
export const CompanyInductionsList = lazy(() => import('./pages/CompanyInductionsList'));
export const CompanyMaps = lazy(() => import('./pages/CompanyMaps'));
export const CompanyProjects = lazy(() => import('./pages/CompanyProjects'));
export const CompanyPortalDashboard = lazy(() => import('./pages/CompanyPortalDashboard'));
export const MyData = lazy(() => import('./pages/MyData'));
export const NotFound = lazy(() => import('./pages/NotFound'));

export const Layout = lazy(() => import('./components/Layout'));
export const ProjectDashboardLayout = lazy(() => import('./components/ProjectDashboardLayout'));
export const CompanyPortalProjectLayout = lazy(() => import('./components/CompanyPortalProjectLayout'));
export const CompanyPortalGuard = lazy(() => import('./components/CompanyPortalGuard'));
